// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { CancellazioniCepDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class CancellazioniCepApiClient extends BaseCRUDApiClient<CancellazioniCepDto> {
  baseUrl = this.config.apiEndpoint + '/cancellazioni-cep';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
